<!--
DashboardHelpSection

Provides the help/documentation links and the role-aware tertiary action in
the dashboard footer. The tertiary action points to upload for users who can
upload, or to the viewer for read-only users.

Permission rules:
- summary.permissions.canUpload decides whether the upload CTA is shown.
- dashboardRole is only used for copy selection.

@author Williams Francis <w.francis@nationaldrones.com> | <olawalewilliams9438@gmail.com>
-->
<template>
    <section class="workspace-dashboard__help" data-home-tour-help>
        <v-card class="workspace-dashboard__help-card" elevation="0">
            <div class="workspace-dashboard__section-head">
                <div>
                    <div class="workspace-dashboard__section-kicker">Help & support</div>
                    <h2>Onboarding, docs, and assistance</h2>
                </div>
            </div>
            <div class="workspace-dashboard__action-grid workspace-dashboard__action-grid--support">
                <a class="workspace-dashboard__action-tile" :href="summary.links?.docs || 'https://help.ndsmartdata.com/en/'" target="_blank">
                    <v-icon>$vuetify.icons.help</v-icon>
                    <strong>Documentation</strong>
                    <span>Guides, format requirements, and setup walkthroughs.</span>
                </a>
                <a class="workspace-dashboard__action-tile" :href="summary.links?.support || '/support/'">
                    <v-icon>$vuetify.icons.email</v-icon>
                    <strong>Support</strong>
                    <span>Reach SmartData support for onboarding and technical help.</span>
                </a>
                <a class="workspace-dashboard__action-tile" :href="tertiaryHref">
                    <v-icon>{{ tertiaryIcon }}</v-icon>
                    <strong>{{ tertiaryTitle }}</strong>
                    <span>{{ tertiaryCopy }}</span>
                </a>
            </div>
        </v-card>
    </section>
</template>

<script>
export default {
    name: 'DashboardHelpSection',
    props: {
        summary: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        dashboardRole() {
            return this.summary.dashboardRole || 'none';
        },
        permissions() {
            return this.summary.permissions || {};
        },
        tertiaryHref() {
            return this.permissions.canUpload
                ? this.summary.links?.upload || '/upload'
                : this.summary.links?.viewer || '/view';
        },
        tertiaryIcon() {
            return this.permissions.canUpload
                ? '$vuetify.icons.upload'
                : '$vuetify.icons.eye';
        },
        tertiaryTitle() {
            return this.permissions.canUpload
                ? 'Continue onboarding'
                : this.dashboardRole === 'team_member'
                  ? 'Open Viewer'
                  : 'Review datasets';
        },
        tertiaryCopy() {
            return this.permissions.canUpload
                ? 'Jump directly into your next upload or hosted dataset activation.'
                : this.dashboardRole === 'team_member'
                  ? 'Open the viewer to explore datasets shared with your team.'
                  : 'Review the datasets and assets currently available in your workspace.';
        },
    },
};
</script>
